module.exports = __webpack_public_path__ + "fonts/Inter-SemiBold.3be6b9e.woff2";